import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vex-pause-dialog',
  templateUrl: './pause-dialog.component.html',
  styleUrls: ['./pause-dialog.component.scss']
})
export class PauseDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService) { }

  ngOnInit(): void {
  }

  stopWorkout(){
    console.debug('hai stoppato l allenamento')
    this.dialogRef.close()
  }

  close(){
    this.dialogRef.close('true')
  }
}
